import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzHlwn80 } from './pages'

type TIdToPageMapWoofzHlwn80 = Record<PageIdWoofzHlwn80, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_HLWN_80: TIdToPageMapWoofzHlwn80 = {
  [PageId.SUBSCRIPTIONS_PAGE_HLWN_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_80/pages/subscriptions/SubscriptionHlwn80'
      ).then((m) => ({
        default: m.SubscriptionsHlwn80,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_80/pages/subscriptions/SubscriptionHlwn80'
      ),
  },
  [PageId.CHAT_UPSELL_HLWN_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_80/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_80/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_HLWN_80]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_hlwn/woofz_hlwn_80/pages/upsell/Upsell').then(
        (m) => ({
          default: m.Upsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_hlwn/woofz_hlwn_80/pages/upsell/Upsell'),
  },
  [PageIdWoofzHlwn80.DOWNLOAD_HLWN_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_80/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_hlwn/woofz_hlwn_80/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzHlwn80.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
